<template>
  <div class='ma-4'>
    <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
    <ClientNav/>
    <v-row>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" outlined tile height="100%">
        <v-data-table
        :headers="headers"
        :items="habs"
        sort-by="Type"
        sort-desc
        :loading="isLoading"
        loading-text="Loading HAB Plans"
        :search="search"
        height="550"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
          <v-toolbar-title>HAB Plans</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
              v-model="search"
              clearable
              flat
              solo-inverted
              hide-details
              prepend-inner-icon="search"
              label="search"
              class="desktop"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="100%">
            <template v-slot:activator="{ on }">
            <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()" v-if="role != 'Direct Care Staff'"
                >
                <v-icon left>add</v-icon>
                Add HAB Plan</v-btn
            >
            </template>
              <v-card>
                <v-card-title style="background-color: #2b3990">
                    <span class="headline white--text">{{ titleForm  }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form
                      ref="form"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="12" sm="12" >
                          <v-textarea
                              v-model="newDesiredOutcome"
                              label="Desired Outcomes"
                              outlined
                              :rules="requiredField"
                              :readonly="readonly"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            v-model="newGoal"
                            label="Goal"
                            :readonly="readonly"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            label="Scope/Objective"
                            v-model="newScope"
                            :readonly="readonly"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-menu
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="newStartDate"
                                label="Start Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="newStartDate"
                              no-title
                              scrollable
                              :rules='requiredField'
                              :readonly="readonly"
                                >
                              <v-spacer></v-spacer>
                              <v-btn
                                  text
                                  color="primary"
                                  @click="menu2 = false"
                              >
                                  Cancel
                              </v-btn>
                              <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu2.save(newStartDate)"
                              >
                                  OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="12" md="6">
                          <v-menu
                            ref="menu3"
                            v-model="menu3"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="newEndDate"
                                  label="End Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="newEndDate"
                              no-title
                              scrollable
                              :readonly="readonly"
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu3 = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu3.save(newEndDate)"
                            >
                              OK
                            </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" class="ma-8">
                            <h3>OUTCOME</h3>
                        </v-col>
                        <v-col cols="12" md="2"></v-col>

                        <v-col cols="12" sm="12" md="2" class="ml-8 mb-6">
                          <v-checkbox
                            label="Met"
                            v-model="newMet"
                            :readonly="readonly"
                          ></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="12" md="2">
                          <v-checkbox
                            label="Revised"
                            v-model="newRevised"
                            :readonly="readonly"
                          ></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="12" md="2">
                          <v-checkbox
                            label="Deferred"
                            v-model="newDeferred"
                            :readonly="readonly"
                          ></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="12" md="2">
                          <v-checkbox
                            label="Deleted"
                            v-model="newDeleted"
                            :readonly="readonly"
                          ></v-checkbox>
                        </v-col>

                        <v-col cols="12" md="3">
                          <v-menu
                            ref="calendarMenu"
                            v-model="calendarMenu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="newOutcomeDate"
                                label="Outcome Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :rules='requiredField'
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="newOutcomeDate"
                              no-title
                              scrollable
                              :rules='requiredField'
                              :readonly="readonly"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="calendarMenu = false"
                              >
                                  Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.calendarMenu.save(newOutcomeDate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                          <v-text-field
                            label="Provider"
                            v-model="newProvider"
                            :readonly="readonly"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="3">
                          <v-text-field
                              label="Service plan Written By"
                              v-model="newWrittenBy"
                              readonly
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="3">
                            <v-text-field
                                label="Person responsible to carry out steps"
                                v-model="newPerson"
                                :readonly="readonly"

                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="ma-8">
                            <h3 class="text-uppercase">Procedure to implement plan</h3>
                        </v-col>

                        <v-col cols="12" class="text-center">
                            <h3>Methods/Steps for teaching skills to attain objective</h3>
                        </v-col>

                        <v-col cols="12" >
                          <v-list
                            v-for="(step, index) in newSteps"
                            :key="index"
                          >
                            <v-list-item>
                              <h3 class="mr-4">Step {{index + 1}}</h3>
                                {{step.StepDescription}}
                            </v-list-item>
                          </v-list>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea
                                outlined
                                label="Please describe in detail"
                                v-model="newStep"
                                :readonly="readonly"

                            ></v-textarea>
                            <v-btn
                                @click="addStep(newStep)"
                                :readonly="readonly"

                            >Add Step</v-btn>
                        </v-col>

                        <v-col cols="12">
                            <span>Verifcation of Training</span>
                        </v-col>

                        <v-col cols="12">
                            <span>Support Plan </span>
                            <v-text-field
                              label="Support Plan Name"
                              v-model="newSupportPlan"
                              :readonly="readonly"
                              >
                            </v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <span>I certify that I have been trained and have reviewed this action plan.
                                I have been given the opportunity to ask questions.
                            </span>
                        </v-col>

                        <v-col cols="12" sm="12" md="4">
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="newSignedDate"
                                label="Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="newSignedDate"
                              no-title
                              scrollable
                              :readonly="readonly"

                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(newSignedDate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="12" md="4">
                            <v-text-field
                                label="Staff Name and Title"
                                v-model="newStaffName"
                                :readonly="readonly"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="4">
                            <v-text-field
                                label="Staff Signature"
                                v-model="newStaffSignature"
                                @click="addStaffSignature()"
                                :readonly="readonly"
                            ></v-text-field>
                        </v-col>

                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="white--text" color="#259647" @click="addHab()" v-if="newHab" >Save</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="updateHab()" v-if="editHab">Update</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="search"
            label="search"
            class="mobile ml-5 mr-5 mb-3 mt-3"
          ></v-text-field>
        </template>

        <template v-slot:item.actions="{ item }">
        <span v-if="item.Document != null">
            <v-icon small class="mr-2" @click="downloadDocument(item)">
                mdi-download
            </v-icon>
        </span>
            <v-icon small class="mr-2" @click="viewHab(item)">
            mdi-eye
            </v-icon>
            <v-icon small class="mr-2" @click="exportCSVHab(item)">
              mdi-export
            </v-icon>
            <v-icon
                small
                @click="deleteHab(item)"
                :readonly="readonly"

            >
            mdi-delete
            </v-icon>
        </template>
        <template v-slot:no-data>
            <v-btn color="#2b3990" class="white--text" @click="getHabs()">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
      </v-col>
    </v-row>
    <Foot/>
  </div>
</template>
<script>
import axios from 'axios'
// import moment from 'moment'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'

const url = require("../../client_config/config").url;

export default {
  components: {
      ClientNav,
      ClientSide,
      Foot,
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Start Date',
          align: 'start',
          sortable: false,
          value: 'StartDate',
        },
        { text: "Desired Outcome", value: "DesiredOutcome" },
        { text: "Goal", value: "Goal" },
        { text: "Written By", value: "WrittenBy" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      dialog: false,
      editHab: false,
      newHab: false,
      msg: false,
      search: "",
      text:"",
      users: [],
      staff: localStorage.getItem('Name'),
      clientID: null,
      userID: localStorage.getItem("userID"),
      writtenBySig: "",
      staffSignature: false,
      supervisorSignature: false,
      managerSignature: false,
      reviewedSignature: false,
      calendarMenu: false,
      calendar2Menu: false,
      newDesiredOutcome: "",
      newGoal: "",
      newScope: "",
      newStartDate: "",
      newEndDate: "",
      newOutcome: "",
      newMet: "",
      newRevised: "",
      newDeferred: "",
      newDeleted: "",
      newOutcomeDate: "",
      newProvider: "Redhead Supports",
      newWrittenBy: "",
      newPerson: "",
      newSteps: [],
      newStep: [],
      newSupportPlan: "",
      newSignedDate: "",
      newStaffName: "",
      newStaffSignature: "",
      habID: "",
      steps: [],
      menu: false,
      menu2: false,
      menu3: false,
      role: localStorage.getItem('userRole'),
      readonly: false,
      editedIndex: -1,
      editedItem: {
        desiredOutcome: "",
        goal: "",
        scope: "",
        startDate: "",
        endDate: "",
        outcome: "",
        met: "",
        revised: "",
        deferred: "",
        deleted: "",
        outcomeDate: "",
        provider: "",
        writtenBy: "",
        person: "",
        steps: "",
        supportPlan: "",
        signedDate: "",
        staffName: "",
        staffSignature: "",

      },
      defaultItem: {
        desiredOutcome: "",
        goal: "",
        scope: "",
        startDate: "",
        endDate: "",
        outcome: "",
        met: "",
        revised: "",
        deferred: "",
        deleted: "",
        outcomeDate: "",
        provider: "",
        writtenBy: "",
        person: "",
        steps: "",
        supportPlan: "",
        signedDate: "",
        staffName: "",
        staffSignature: "",

      },
      isLoading: true,
      habs: [],
      titleForm: "",
      date: "",
      requiredField: [(v) => !!v || "This is required"],
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.clientID = this.$route.params.clientID;
    this.getHabs();
    this.addSignature();
    if(this.role == 'Direct Care Staff'){
      this.readonly = true;

    }
  },

  methods: {
    initialize() {
      this.habs = [];
    },

    validate () {
      return this.$refs.form.validate()
    },
    validateReset(){
      if(this.$refs.form !== undefined){
        this.$refs.form.reset();
      }
    },

    viewHab(item) {

      this.titleForm= "Viewing HAB Plan";
      this.dialog = true;
      this.editHab = true;
      this.newHab = false;
      this.newDesiredOutcome = item.DesiredOutcome;
      this.newGoal = item.Goal;
      this.newScope = item.Scope
      this.newStartDate = item.StartDate;
      this.newEndDate = item.EndDate;
      this.newOutcome = item.Outcome;
      this.newMet = item.Met;
      this.newRevised = item.Revised;
      this.newDeferred = item.Deferred;
      this.newDeleted = item.Deleted;
      this.newOutcomeDate = item.OutcomeDate;
      this.newProvider = item.Provider;
      this.newWrittenBy = item.WrittenBy;
      this.newPerson = item.Person;
      this.newSteps = item.Steps;
      this.newSupportPlan = item.SupportPlan;
      this.newSignedDate = item.SignedDate;
      this.newStaffName = item.StaffName;
      this.newStaffSignature = item.StaffSignature;
      this.habID = item._id;
    },
    showAdd() {
      this.titleForm= "New Hab Plan";
      this.newHab = true;
      this.editHab = false;
    },

    deleteHab(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this HAB plan?") &&
      this.habDelete(id);
    },

    downloadDocument(item){
      let documentName = item.Document?.Name || '';
      let documentLink = item.Document?.AWSLink || '';
      var FileSaver = require('file-saver');
      FileSaver.saveAs(documentLink, documentName);
     },

    habDelete(id) {
      axios.delete(`${url}/hab/${id}`)
      .then((response) => {
        this.getHabs();
        if (response.status == 400) {
          response.json().then(function(data) {
            return data.msg;
          });
        }
        this.msg=true;
        this.text="The HAB Plan has been deleted successfully.";
      });
    },

    exportCSVHab(item){
      let habID  = item._id;
      window.location.href = `${url}/hab/download?habID=${habID}`;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.clearFields()
      });
    },

    updateHab() {
      var req_body = {
        DesiredOutcome: this.newDesiredOutcome,
        Goal: this.newGoal,
        Scope: this.newScope,
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        Outcome: this.newOutcome,
        Met: this.newMet,
        Revised: this.newRevised,
        Deferred: this.newDeferred,
        Deleted: this.newDeleted,
        OutcomeDate: this.newOutcomeDate,
        Provider: this.newProvider,
        WrittenBy: this.newWrittenBy,
        Person: this.newPerson,
        Steps: this.newSteps,
        SupportPlan: this.newSupportPlan,
        SignedDate: this.newSignedDate,
        StaffName: this.newStaffName,
        StaffSignature: this.newStaffSignature,

      };
      axios.put(`${url}/hab/${this.habID}`, req_body).then((response) => {
        this.getHabs();
        if (response.status == 400) {
          response.json().then(function(data) {
            alert(data.msg);
          });
        }
      this.msg=true;
      this.text="The HAB Plan has been updated successfully.";
      });
      this.close();
    },
    getHabs: function() {
      this.isLoading = true;
      axios.get(`${url}/hab/plan/${this.clientID}`).then(res => {
        this.habs = res.data.habs
      }).finally(() => this.isLoading = false);
    },

    addHab: async function() {
      var req_body = {
        DesiredOutcome: this.newDesiredOutcome,
        Goal: this.newGoal,
        Scope: this.newScope,
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        Outcome: this.newOutcome,
        Met: this.newMet,
        Revised: this.newRevised,
        Deferred: this.newDeferred,
        Deleted: this.newDeleted,
        OutcomeDate: this.newOutcomeDate,
        Provider: this.newProvider,
        WrittenBy: this.newWrittenBy,
        Person: this.newPerson,
        Steps: this.steps,
        SupportPlan: this.newSupportPlan,
        SignedDate: this.newSignedDate,
        StaffName: this.newStaffName,
        StaffSignature: this.newStaffSignature,
        ClientID: this.clientID,
      };

      const isValid = await this.$refs.form.validate();

      if(isValid){
        axios.post(`${url}/hab`, req_body ).then(res => {
          this.getHabs();
          if (res.status == 400) {
            res.json().then(function(data) {
              this.text=data.msg;
            });
          }
        this.msg=true;
        this.text="The new HAB Plan has been added successfully.";
        this.habID = res.data._id
        // if(this.uploadFile !== null && this.uploadFile !== undefined){
        //     this.saveFile()
        // }

        });
        this.close();
      }

    },

    addSignature: function() {
      if (this.newWrittenBy == ""){
        this.writtenBySig = true;
        // this.newWrittenBy = this.staff + " - " + new Date();
        this.newWrittenBy = this.staff
      } else {
        this.newWrittenBy = ""
        this.writtenBySig = false;
      }
    },

    addStaffSignature: function() {
      if (this.newStaffSignature == ""){
        this.staffSignature = true;
        this.newStaffSignature = this.staff + " - " + new Date();
      } else {
        this.newStaffSignature = ""
        this.staffSignature = false;
      }
    },


    fileSelected(e) {
    this.uploadFile=e;
    },
    saveFile() {
      const formData = new FormData();
      formData.append('incidents', this.uploadFile);
      var ct = { headers:{"content-type" : "multipart/form-data"}};
      axios.post(`${url}/incidents/fileUploader/${this.incidentID}/${this.clientID}`,formData, ct)
      .then(res => {
        if(res){
          this.getIncidents();
        }
      })
      .catch(err => {
        console.log(err);
      });
    },

    clearFields() {
        this.newDesiredOutcome = "";
        this.newGoal = "";
        this.newScope = "";
        this.newStartDate = "";
        this.newEndDate = "";
        this.newOutcome = "";
        this.newMet = "";
        this.newRevised = "";
        this.newDeferred = "";
        this.newDeleted = "";
        this.newOutcomeDate = "";
        this.newWrittenBy = "";
        this.newPerson = "";
        this.newSteps = "";
        this.newSupportPlan = "";
        this.newSignedDate = "";
        this.newStaffName = "";
        this.newStaffSignature = "";
    },

    addStep(StepDescription) {
      this.steps.push({"StepDescription": StepDescription})
      this.newSteps.push({"StepDescription": StepDescription})
      this.newStep = ""

    },

  },

};
</script>
